import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar, { MobileNav } from './Sidebar';
import FeedbackTab from './FeedbackTab';
import CopilotPanel from './CopilotPanel';

export default function Layout() {
  const [menu, setMenu] = useState(false);
  return (
    <div className="min-h-screen bg-[var(--bg-primary)] text-[var(--text-primary)] flex flex-col font-sans">
      <Header onMenu={() => setMenu(true)} />
      <MobileNav open={menu} onClose={() => setMenu(false)} />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        {/* pb-20 keeps the floating Copilot / Feedback buttons off the last row on phones */}
        <main className="min-w-0 flex-1 overflow-auto p-3 pb-20 sm:p-6 sm:pb-20">
          <Outlet />
        </main>
      </div>
      <FeedbackTab />
      <CopilotPanel />
    </div>
  );
}
